/**
 * Angular 2 decorators and services
 */
import {
  Component,
  OnInit,
  ViewEncapsulation,
  HostBinding,
  ViewChild
} from '@angular/core';
import * as $ from 'jquery/dist/jquery.min.js';


import { AppState } from './app.service';
import { routerTransition } from './fade.animation';
import { Router, NavigationEnd } from '@angular/router';


@Component({
  selector: 'app',
  encapsulation: ViewEncapsulation.None,
  styles: [
    require('./app.component.css')
  ],
  template: require('./app.component.html'),
  animations: [routerTransition]
})

export class AppComponent implements OnInit {
  public angularclassLogo = 'assets/img/angularclass-avatar.png';
  public name = 'The Hour Builder\'s Guide';

  constructor(
    public appState: AppState,
    private router: Router
  ) {}

  getState(outlet) {
    return outlet.activatedRouteData.state;
  }



  public ngOnInit() {
    console.log('Initial App State', this.appState.state);

    // var main_scene = new this.appState.ScrollMagic.Scene({
    //     offset: 30
    //   })
    // .setClassToggle("#main_header", "after_scroll") // add class toggle
    // .addTo(this.appState.controllerMain);


    this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0)
        });


  }

}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/app.component.ts